import { defineComponent, ref, computed, resolveComponent, openBlock, createElementBlock, mergeProps, toHandlers, createElementVNode, normalizeClass, renderSlot, Fragment, createVNode, createBlock, createCommentVNode } from 'vue';
import { a as isVue3 } from '../OrAutocompleteV3-961163d0.js';
import { OrLoaderV3 as script$1 } from '../or-loader-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-4e69972f.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import './index.js';
import '../or-tag-v3/index.js';

var ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["Contained"] = "contained";
  ButtonVariant["Outlined"] = "outlined";
  ButtonVariant["Text"] = "text";
  ButtonVariant["Link"] = "link";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonColor;
(function (ButtonColor) {
  ButtonColor["Primary"] = "primary";
  ButtonColor["Danger"] = "danger";
  ButtonColor["Inherit"] = "inherit";
})(ButtonColor || (ButtonColor = {}));
var ButtonType;
(function (ButtonType) {
  ButtonType["Button"] = "button";
  ButtonType["Submit"] = "submit";
  ButtonType["Reset"] = "reset";
})(ButtonType || (ButtonType = {}));

const Button = [
// Layout
'layout-inline-row',
// Overflow
'overflow-hidden',
// Interactivity
'interactivity-click',
// Shape
'rounded-md',
// Typography
'typography-button'];
const ButtonVariants = {
  [ButtonVariant.Contained]: [
  //  Layout
  'layout-inline-row justify-center',
  // Box
  'min-w-[96px]',
  // Spacing
  'px-md md:px-md', 'py-sm+ md:py-sm'],
  [ButtonVariant.Outlined]: [
  //  Layout
  'layout-inline-row justify-center',
  // Box
  'min-w-[96px]',
  // Spacing
  'px-md* md:px-md*', 'py-sm+* md:py-sm*'],
  [ButtonVariant.Text]: [
  //  Layout
  'layout-inline-row justify-center',
  // Box
  'min-w-[96px]',
  // Spacing
  'px-md md:px-md', 'py-sm+ md:py-sm'],
  [ButtonVariant.Link]: [
  //  Layout
  'layout-inline-row justify-center']
};
const ButtonContainerVariants = {
  [ButtonVariant.Contained]: [
  //  Layout
  'layout-inline-row', 'gap-sm+ md:gap-sm'],
  [ButtonVariant.Outlined]: [
  //  Layout
  'layout-inline-row', 'gap-sm+ md:gap-sm'],
  [ButtonVariant.Text]: [
  //  Layout
  'layout-inline-row', 'gap-sm+ md:gap-sm'],
  [ButtonVariant.Link]: [
  //  Layout
  'layout-inline-row',
  // Spacing
  'gap-xs']
};
const ButtonColors = {
  'primary-contained': [
  // Theme
  'theme-preset-1-primary', 'dark:theme-preset-1-primary-dark',
  // Elevation (enabled)
  'enabled:shadow-button', 'dark:enabled:shadow-button-dark'],
  'danger-contained': [
  // Theme
  'theme-preset-1-error', 'dark:theme-preset-1-error-dark',
  // Elevation (enabled)
  'enabled:shadow-button', 'dark:enabled:shadow-button-dark'],
  'inherit-contained': [
  // Elevation (enabled)
  'enabled:shadow-button', 'dark:enabled:shadow-button-dark'],
  'primary-outlined': [
  // Theme
  'theme-preset-3-primary', 'dark:theme-preset-3-primary-dark', 'theme-border-outline border-1', 'dark:theme-border-outline-dark',
  // Theme (active)
  'active:theme-border-primary active:border-1', 'dark:active:theme-border-primary-dark'],
  'danger-outlined': [
  // Theme
  'theme-preset-3-error', 'dark:theme-preset-3-error-dark', 'theme-border-error border-1', 'dark:theme-border-error-dark'],
  'inherit-outlined': [],
  'primary-text': [
  // Theme
  'theme-preset-4-primary', 'dark:theme-preset-4-primary-dark'],
  'danger-text': [
  // Theme
  'theme-preset-4-error', 'dark:theme-preset-4-error-dark'],
  'inherit-text': [
  // Theme
  'theme-foreground-inherit', 'dark:theme-foreground-inherit-dark'],
  'primary-link': [
  // Theme
  'theme-preset-4-primary', 'dark:theme-preset-4-primary-dark'],
  'danger-link': [
  // Theme
  'theme-preset-4-error', 'dark:theme-preset-4-error-dark'],
  'inherit-link': [
  // Theme
  'theme-foreground-inherit', 'dark:theme-foreground-inherit-dark',
  // Theme (activated)
  'activated:theme-foreground-default', 'dark:activated:theme-foreground-default-dark']
};
const ButtonLoadingColors = {
  'primary-contained': ['interactivity-none', 'bg-primary-hover dark:bg-primary-hover-dark'],
  'danger-contained': ['interactivity-none', 'bg-error-hover dark:bg-error-hover-dark'],
  'inherit-contained': ['interactivity-none'],
  'primary-outlined': ['interactivity-none'],
  'danger-outlined': ['interactivity-none'],
  'inherit-outlined': ['interactivity-none'],
  'primary-text': ['interactivity-none', 'text-primary-hover dark:text-primary-hover-dark'],
  'danger-text': ['interactivity-none', 'text-error-hover dark:text-error-hover-dark'],
  'inherit-text': ['interactivity-none'],
  'primary-link': ['interactivity-none', 'text-primary-hover dark:text-primary-hover-dark'],
  'danger-link': ['interactivity-none', 'text-error-hover dark:text-error-hover-dark'],
  'inherit-link': ['interactivity-none']
};
const ButtonContainerVariantsLoading = {
  'contained': [
  // Position
  'relative', 'flex',
  // Box
  'w-full', 'h-full',
  // Aligment
  'items-center', 'justify-center'],
  'outlined': [
  // Position
  'relative', 'flex',
  // Box
  'w-full', 'h-full',
  // Aligment
  'items-center', 'justify-center'],
  'text': [
  // Position
  'relative', 'flex',
  // Box
  'w-full', 'h-full',
  // Aligment
  'items-center', 'justify-center'],
  'link': ['contents']
};
const ButtonContentLoading = {
  'contained': ['invisible'],
  'outlined': ['invisible'],
  'text': ['hidden'],
  'link': ['hidden']
};

var script = defineComponent({
  name: 'OrButton',
  components: {
    OrLoader: script$1
  },
  props: {
    type: {
      type: String,
      default: () => ButtonType.Button
    },
    variant: {
      type: String,
      default: () => ButtonVariant.Contained
    },
    color: {
      type: String,
      default: () => ButtonColor.Primary
    },
    activated: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Loading'
    }
  },
  emits: ['click', 'focus', 'blur'],
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-button-v3', ...Button, ...ButtonVariants[props.variant], ...ButtonColors[`${props.color}-${props.variant}`], ...(props.loading ? ButtonLoadingColors[`${props.color}-${props.variant}`] : [])]);
    const contentContainerStyles = computed(() => [...ButtonContainerVariants[props.variant], ...(props.loading ? ButtonContainerVariantsLoading[props.variant] : [])]);
    const contentStyles = computed(() => ['contents', ...(props.loading ? ButtonContentLoading[props.variant] : [])]);
    return {
      root,
      rootStyles,
      contentStyles,
      contentContainerStyles,
      isVue3
    };
  }
});

const _hoisted_1 = ["type", "activated", "disabled", "data-loading"];
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/normalizeClass(['absolute'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLoader = resolveComponent("OrLoader");
  return openBlock(), createElementBlock("button", mergeProps({
    ref: 'root',
    class: _ctx.rootStyles,
    type: _ctx.type,
    activated: _ctx.activated,
    disabled: _ctx.disabled,
    "data-loading": _ctx.loading
  }, toHandlers({
    ...(_ctx.isVue3 ? {} : _ctx.$listeners),
    click: e => _ctx.$emit('click', e),
    focus: e => _ctx.$emit('focus', e),
    blur: e => _ctx.$emit('blur', e)
  }, true)), [createElementVNode("div", {
    class: normalizeClass(_ctx.contentContainerStyles)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */), _ctx.loading ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [_ctx.variant == 'contained' || _ctx.variant == 'outlined' ? (openBlock(), createElementBlock("div", _hoisted_2, [createVNode(_component_OrLoader, {
    variant: 'circular',
    color: 'inherit',
    size: 's'
  })])) : (openBlock(), createBlock(_component_OrLoader, {
    key: 1,
    variant: "text",
    text: _ctx.loadingText
  }, null, 8 /* PROPS */, ["text"]))], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)], 16 /* FULL_PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-button-v3/OrButton.vue";

export { ButtonColor, ButtonType, ButtonVariant, script as OrButtonV3 };
